export const translationLivechat_da_part3 = {
  livechatAvatarUploading: "Uploader...",
  livechatAvatarUploaded: "Billede uploadet",
  livechatAvatarUploadFailed: "Upload mislykkedes",
  livechatDisplayNameRequired: "Visningsnavn er påkrævet.",
  livechatSaveProfile: "Gem profil",
  livechatSaving: "Gemmer...",
  livechatClose: "Luk",
  livechatCancel: "Annuller",
  livechatSettingsModalTitleLive: "Live miljø livechat-indstillinger",
  livechatSettingsModalTitleTest: "Test miljø livechat-indstillinger",
  livechatSettingsModalEyebrow: "{chatbotId} · {env} miljø",
  livechatSettingsLoading: "Indlæser indstillinger...",
  livechatSettingsWebhook: "Webhook",
  livechatSettingsEnabledByAdmin: "Aktiveret af administrator",
  livechatSettingsDisabledByAdmin: "Deaktiveret af administrator",
  livechatSettingsConfigured: "Konfigureret",
  livechatSettingsNotConfigured: "Ikke konfigureret",
  livechatSettingsUnavailable: "Ikke tilgængelig",
  livechatSettingsAttachmentRetention: "Opbevaring af vedhæftninger (dage)",
  livechatSettingsTimezone: "Tidszone for arbejdstid",
  livechatSettingsManualAvailability: "Tilgængelighedstilstand",
  livechatSettingsManualAuto: "Følg arbejdstid",
  livechatSettingsManualLive: "Altid online",
  livechatSettingsManualOffline: "Altid offline",
  livechatSettingsTranslationMode: "Livechat-oversættelse",
  livechatSettingsTranslationOff: "Fra",
  livechatSettingsTranslationManual: "Besøgende kan oversætte",
  livechatSettingsTranslationAuto: "Oversæt automatisk",
  livechatSettingsTranslationHelp:
    "Gælder kun agentbeskeder i chatbotten. Automatisk oversættelse bruger samtalens AI-detekterede sprog og falder tilbage til chatbot-sproget.",
  livechatSettingsShowLogo: "Vis livechat-knappen i chattens topbar",
  livechatSettingsShowLogoHelp: "Headset-knappen, som besøgende bruger til at åbne livechatten.",
  livechatSettingsHideHeaderButtonLabel: "Lad besøgende starte en livechat fra knappen",
  livechatSettingsHideHeaderButtonHelp:
    "Når den er slået fra, kan besøgende ikke selv starte en livechat fra topbaren. AI-styrede overleveringer og kontaktformularer med livechat virker stadig, og knappen vises under en aktiv livechat, så den kan afsluttes.",
  livechatSettingsWorkingHours: "Arbejdstid",
  livechatSettingsAddHours: "Tilføj tidsrum",
  livechatSettingsNoHours: "Ingen tidsrum",
  livechatSettingsRemove: "Fjern",
  livechatSettingsSave: "Gem indstillinger",
  livechatSettingsSaving: "Gemmer...",
  livechatSettingsRetentionInteger: "Dage for opbevaring af vedhæftninger skal være et heltal.",
  livechatWeekdayMonday: "Mandag",
  livechatWeekdayTuesday: "Tirsdag",
  livechatWeekdayWednesday: "Onsdag",
  livechatWeekdayThursday: "Torsdag",
  livechatWeekdayFriday: "Fredag",
  livechatWeekdaySaturday: "Lørdag",
  livechatWeekdaySunday: "Søndag",
  livechatAvailabilityDisabled: "Deaktiveret",
  livechatAvailabilityManualLive: "Sat online manuelt",
  livechatAvailabilityManualOffline: "Sat offline manuelt",
  livechatAvailabilityAlwaysOn: "Ingen arbejdstid angivet, altid online",
  livechatAvailabilityWithinHours: "Inden for arbejdstid",
  livechatAvailabilityOutsideHours: "Uden for arbejdstid",
  livechatEnvironmentWordLive: "Live",
  livechatEnvironmentWordTest: "Test",
  livechatRelativeJustNow: "lige nu",
  livechatRelativeSecondsAgo: "{count}s siden",
  livechatRelativeMinutesAgo: "{count}m siden",
  livechatRelativeHoursAgo: "{count}t siden",
  livechatRelativeDaysAgo: "{count}d siden",
  livechatDurationSeconds: "{count}s",
  livechatDurationMinutes: "{count}m",
  livechatDurationHoursMinutes: "{hours}t {minutes}m",
  livechatDurationHours: "{count}t",
  livechatDurationDays: "{count}d",
  livechatWaitingForLabel: "Venter",
  livechatActiveForLabel: "Aktiv",
  livechatClosedAgoLabel: "Lukket",
  livechatVisitorTitleFallback: "Besøgende",
  livechatNewBadge: "Ny",
  livechatComposerKeyboardHint: "Enter for at sende · Shift+Enter for ny linje",
  livechatRemoveAttachment: "Fjern vedhæftning",
  livechatAttachFiles: "Vedhæft filer",
  livechatDropFilesHint: "Slip filerne for at vedhæfte dem",
  livechatInsertEmoji: "Indsæt emoji",
  livechatNoSessionTipsTitle: "Ingen samtale valgt",
  livechatNoSessionTipsHint:
    "Vælg en session fra listen til venstre, eller skift fane for at se ventende, aktive eller lukkede samtaler.",
  livechatNoSessionsHeadline: "Alt roligt her",
  livechatNoSessionsHintWaiting: "Der venter ingen kunder lige nu. Nye samtaler vises automatisk.",
  livechatNoSessionsHintActive:
    "Du har ingen aktive samtaler. Skift til Venter for at hente en ny.",
  livechatNoSessionsHintClosed: "Ingen lukkede samtaler endnu i dette filter.",
  livechatNoSearchResultsHeadline: "Ingen resultater",
  livechatNoSessionsHintSearch:
    'Ingen samtaler matcher "{query}" i dette filter. Prøv et andet søgeord eller skift fane.',
  livechatSearchSessionsPlaceholder: "Søg i samtaler, ID'er, besøgende eller kundedata...",
  livechatSearchSessionsAria: "Søg i livechat-samtaler",
  livechatSearchMatchLabel: "Søgematch",
  livechatClearSearch: "Ryd søgning",
  livechatNoSessionsHintDefault: "Ingen sessioner matcher de valgte filtre.",
  livechatHeaderAvailabilityLabel: "Tilgængelighed",
  livechatHeaderAvailabilityLive: "Online",
  livechatHeaderAvailabilityOffline: "Offline",
  livechatHeaderAvailabilityLoading: "Henter…",
  livechatAvailabilityToggleLabel: "Sæt livechat online eller offline for {chatbotId}",
  livechatAvailabilityToggleHint:
    "Manuel overstyring. Vælg “Følg arbejdstid” under Indstillinger for at bruge arbejdstiden i stedet.",
  livechatHeaderEnvLabel: "Miljø",
  livechatHeaderChatbotLabel: "Chatbot",
  livechatVisitorOtherSessionsCount: "{count} flere sessioner fra denne besøgende",
  livechatVisitorOtherSessionsCountSingular: "1 flere session fra denne besøgende",
  livechatHideOtherSessions: "Skjul",
  livechatShowOtherSessions: "Vis alle",
  livechatLastUpdated: "Senest opdateret",
  livechatSettingsButton: "Indstillinger",
  livechatSettingsForChatbot: "Livechat-indstillinger for {chatbotId}",
  livechatSettingsChooseChatbot: "Vælg hvilken chatbot der skal konfigureres",
  livechatSettingsNoChatbots: "Ingen chatbots tilgængelige",
  livechatSettingsSectionAvailability: "Tilgængelighed",
  livechatSettingsSectionAvailabilityHelp:
    "Styrer hvornår besøgende kan starte en livechat med denne chatbot.",
  livechatSettingsManualAvailabilityHelp:
    "Følg arbejdstid bruger tidsrummene nedenfor. Altid online eller Altid offline overstyrer dem, indtil du ændrer det igen.",
  livechatSettingsWorkingHoursHelp: "Livechat er online i disse tidsrum, når arbejdstiden følges.",
  livechatSettingsWorkingHoursIgnored:
    "Arbejdstiden bruges ikke, mens tilgængeligheden er sat til Altid online eller Altid offline.",
  livechatSettingsSectionWidget: "Chat-widget",
  livechatSettingsSectionWidgetHelp: "Sådan kommer besøgende til livechatten fra chatbotten.",
  livechatSettingsSectionTranslation: "Oversættelse",
  livechatSettingsSectionData: "Dataopbevaring",
  livechatSettingsAttachmentRetentionHelp:
    "Filer uploadet i livechats slettes efter dette antal dage.",
  livechatSettingsWorkingHoursNoneSet:
    "Ingen tidsrum angivet: livechat er online hele døgnet. Tilføj tidsrum for at begrænse det.",
  livechatSettingsSlotInvalid: "Hvert tidsrum skal have et sluttidspunkt efter starttidspunktet.",
  livechatFilterHint: "Filtrer samtaler efter chatbot",
  livechatFilterSelectedOfTotal: "{count} af {total} chatbots",
  livechatFilterAllInScope: "Alle chatbots i {scope}",
  livechatFilterSearchPlaceholder: "Søg efter chatbots…",
  livechatFilterNoMatches: "Ingen chatbots matcher din søgning.",
  livechatFilterOnly: "Kun",
  livechatFilterOnlyChatbot: "Kun {chatbot}",
  livechatVerifiedMetadata: "Verificerede kundedata",
  livechatVerifiedMetadataHint:
    "Signeret af kundens website og verificeret af os, så oplysningerne kan stoles på.",
  livechatRoutedTo: "Sendt til",
  livechatAcceptedBy: "Taget af",
  livechatGroupsButton: "Grupper",
  livechatGroupsTitle: "Livechat-grupper",
  livechatGroupsDescription:
    'Grupper er teams af agenter, som en kontaktformular kan sende chats til, fx "Back Office". Medlemmerne slås op, når chatten kommer ind, så I kan ændre holdet dagligt. Grupper deles af alle chatbots i organisationen.',
  livechatGroupsEmpty: "Ingen grupper endnu. Opret en for at sende formular-chats til et team.",
  livechatGroupsNew: "Ny gruppe",
  livechatGroupsLoadFailed: "Grupperne kunne ikke hentes.",
  livechatGroupName: "Gruppenavn",
  livechatGroupNamePlaceholder: "Back Office",
  livechatGroupNameRequired: "Giv gruppen et navn.",
  livechatGroupMembers: "Medlemmer",
  livechatGroupMembersCount: "{count} medlemmer",
  livechatGroupMembersOne: "1 medlem",
  livechatGroupNoCandidates: "Ingen brugere fundet i organisationen.",
  livechatGroupUnknownMember: "Ukendt bruger (ikke længere i organisationen)",
  livechatGroupSave: "Gem gruppe",
  livechatGroupCreate: "Opret gruppe",
  livechatGroupDelete: "Slet gruppe",
  livechatGroupDeleteConfirm:
    "Slet gruppen? Formularer, der sender til den, falder tilbage til den fælles kø.",
  livechatGroupSaveFailed: "Gruppen kunne ikke gemmes.",
  livechatGroupDeleteFailed: "Gruppen kunne ikke slettes.",
  livechatGroupNameTaken: "Der findes allerede en gruppe med det navn.",
  livechatGroupsClose: "Luk",
  livechatGroupsSelectHint: "Vælg en gruppe for at redigere navn og medlemmer.",
  livechatRoutingTimeLeft: "{time} tilbage til de valgte agenter",
  livechatRoutingFallbackTimeout: "ingen af de valgte agenter svarede, åben for alle",
  livechatRoutingFallbackNoOnline: "ingen af de valgte agenter var online, åben for alle",
  livechatRoutingFallbackNoAgents:
    "ingen af de valgte agenter har en livechat-profil her, åben for alle",
  livechatSettingsSectionRouting: "Sendte chats",
  livechatSettingsSectionRoutingHelp:
    "Kontaktformularer kan sende chats til en livechat-gruppe. Så længe mindst ét medlem er online, ser kun gruppen chatten; efter tidsfristen åbnes den for alle. Indstillingen gælder hele organisationen.",
  livechatSettingsRoutingTimeout: "Åbn for alle efter (minutter)",
  livechatSettingsRoutingTimeoutHelp:
    "Hvor længe en sendt chat venter på gruppen, før alle agenter ser den. 1 til 60 minutter, standard 3.",
  livechatSettingsRoutingTimeoutInvalid: "Tidsfristen skal være et helt tal mellem 1 og 60.",
  livechatBulkHoursTitle: "Anvend åbningstider på flere chatbots",
  livechatBulkHoursHelp:
    "Kopiér åbningstiderne og tidszonen ovenfor. Andre ændringer, der ikke er gemt, medtages ikke.",
  livechatBulkHoursTargets: "Vælg chatbots",
  livechatBulkHoursClear: "Ryd valg",
  livechatBulkHoursSelectAll: "Vælg alle",
  livechatBulkHoursPreview: "Erstat åbningstider på {count} chatbots",
  livechatBulkHoursPreserve:
    "Manuel tilgængelighed gælder fortsat. Deaktiverede chatbots forbliver deaktiverede. Andre indstillinger ændres ikke.",
  livechatBulkHoursFailed:
    "Opdateringen kunne ikke bekræftes. Kontrollér indstillingerne, før du prøver igen.",
  livechatBulkHoursSaved: "Åbningstiderne er anvendt på de valgte chatbots.",
  livechatBulkHoursApply: "Anvend på {count} chatbots",
  livechatBulkHoursReview: "Gennemse valgte chatbots",
  livechatBulkHoursTargetsFailed:
    "Kunne ikke hente chatbots for den aktive organisation. Luk og åbn denne sektion for at prøve igen.",
};
